import React from 'react'
//import { useIntakeAlertService } from '../services/IntakeAlertService'
import { Alert } from 'reactstrap'

const GlobalAlert = ({alert}) => {
  

  //const alertRef = useRef({hasAlert: false})

  return (
    (alert && alert.hasAlert) ? (
      <div className='container'>
        <Alert color={alert.color} style={{textAlign: 'center'}}>
          {alert.alert}
        </Alert>
      </div>
    ) : (
      <></>
    )
  )
}

export default GlobalAlert